"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function ListItem(_a) {
    var ecapture = _a.ecapture, onDelete = _a.onDelete;
    return react_1.default.createElement(storybook_1.Lists.Item, null,
        react_1.default.createElement(storybook_1.Lists.Content, null,
            react_1.default.createElement(storybook_1.Texts.Primary, { appendClassname: 'w-full' }, ecapture.email)),
        react_1.default.createElement(storybook_1.Lists.Buttons, null,
            react_1.default.createElement(storybook_1.Buttons.Button, { className: 'storybook-hide-sm', onClick: function () { return onDelete({ id: ecapture.id }); } },
                react_1.default.createElement(storybook_1.Icons.Icon, { name: 'trash', className: 'storybook-icons-icon text-disabled' }))));
}
exports.default = ListItem;
ListItem.propTypes = {};
ListItem.defaultProps = {};
